import { Component, ComponentInterface, Host, JSX, h } from '@stencil/core';

import { StoreKeys } from '../../../shared/constants/store-keys.enum';
import { changePlanService } from '../../services/change-plan/change-plan.service';
import { store } from '../../../shared/store/store';

@Component({
  tag: 'nbn-fibre-upgrade-message',
  styleUrl: 'nbn-fibre-upgrade-message.scss'
})
export class NbnFibreUpgradeMessage implements ComponentInterface {
  render(): JSX.Element {
    const isChangePlan = changePlanService.isChangePlan();
    let showFibreUpgradeMessage = false;
    if (isChangePlan) {
      const productDetails = store.get(StoreKeys.productDetails);
      const selectedProductSku = changePlanService.getSelectedProductSku();
      const hasFibreUpgrade = productDetails.products.some((p) => p.fibreUpgrade);
      const selectedProductPlan = productDetails.products.find((p) => p.sku === selectedProductSku);
      showFibreUpgradeMessage = !selectedProductPlan && hasFibreUpgrade;
    }

    return (
      showFibreUpgradeMessage && (
        <Host>
          <div class="fibre-upgrade-message">
            <div class="fibre-upgrade-message__container">
              <dls-h5 class="fibre-upgrade-message__title">{`Great news! You’re eligible for a $0 fibre upgrade.*`}</dls-h5>
              <dls-p class="fibre-upgrade-message__subtitle">
                Get faster, more reliable internet when you upgrade your current technology, Fibre to the building (FTTB), to full fibre.
                <br />
                <dls-link href="#faq_wrapper">Learn more</dls-link>
              </dls-p>
            </div>
          </div>
        </Host>
      )
    );
  }
}
